<template>
    <CCol md="5">
        <CCard class="p-4">
            <CCardBody>
                <CForm>
                    <img
                        alt="Leadgrease logo"
                        class="mb-4"
                        src="@sset/leadgrease.png"
                    />
                    <h4>{{ $t("reset_password") }}</h4>
                    <CInput
                        type="email"
                        :lazy="false"
                        :value.sync="$v.form.email.$model"
                        :isValid="checkIfValid('email')"
                        :placeholder="`${$t('email')}`"
                        autocomplete="email"
                    />
                    <CButton
                        block
                        color="primary"
                        class="px-4"
                        @click="send"
                        :disabled="form._loading"
                    >
                        <CSpinner
                            class="mr-1"
                            color="light"
                            size="sm"
                            v-if="form._loading"
                        />
                        {{ $t("send_password_reset_link") }}
                    </CButton>
                </CForm>
            </CCardBody>
        </CCard>
        <hr />
        <div class="small ml-auto my-auto text-right">
            <router-link :to="{ name: 'login' }" class="">
                {{ $t("go_back") }}
            </router-link>
        </div>
    </CCol>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import pageMixin from "~/mixins/page.js";
export default {
    name: "ResetPassword",

    layout: "basic",

    middleware: "guest",

    metaInfo() {
        return { title: this.$t("reset_password") };
    },

    data: () => ({
        form: {
            email: "",
            _loading: false,
        },
    }),

    computed: {
        isValid() {
            return !this.$v.form.$invalid;
        },
    },

    mixins: [validationMixin, pageMixin],

    validations: {
        form: {
            email: {
                required,
                email,
            },
        },
    },

    methods: {
        checkIfValid(fieldName) {
            const field = this.$v.form[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },

        async send() {
            this.$v.$touch();
            
            try {
                
                if (this.$v.form.$invalid)
                    throw { code: 422, message: this.$t("invalid_data") };
                this.form._loading = true;
                let form = {...this.form};
                delete form._loading;
                const { data } = await axios.post(
                    "/reset-password",
                    form,
                    {
                        baseURL: "https://auth.leadgrease.com",
                    }
                );

                this.form._loading = false;

                this.$router.push({
                    name: "confirm_reset_password",
                    params: { 
                        lang: this.$route.params.lang, 
                        email: this.form.email
                    },
                });

            } catch (error) {
                this.showMessageError(error);
                form._loading = false;
                throw error;
            }
        },
    },
};
</script>
